export function exportCSVFile(data, fileTitle) {
  var exportedFilename = fileTitle + ".csv" || "export.csv";

  var blob = new Blob([data], { type: "text/csv;charset=utf-8;" });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, exportedFilename);
  } else {
    var link = document.createElement("a");
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", exportedFilename);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}

export function downloadBlob(blob, fileName) {
  const url = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
}

export const emptyGridValue = "--";

export function gridValue(val) {
  let hasValue = true;
  switch (typeof val) {
    case "object":
    case "undefined": {
      if (!val) hasValue = false;
      break;
    }
    case "string": {
      if (isEmptyOrSpaces(val)) hasValue = false;
      break;
    }
  }

  return hasValue ? val : emptyGridValue;
}

export function gridItem(headers, obj) {
  let result = {}; // don't mutate source

  for (let i = 0; i < headers.length; i++) {
    let key = headers[i].value;
    result[key] = gridValue(obj[key]);
  }

  return result;
}

export function isEmptyOrSpaces(str) {
  return str === null || str.match(/^ *$/) !== null;
}

export function factorialize(num) {
  if (num < 0) return -1;
  else if (num == 0) return 1;
  else {
    return num * factorialize(num - 1);
  }
}

export function formattedTimestamp(val) {
  if (!val) return null;
  
  let d = new Date(val);
  const date = d.getDate() + "";
  const month = d.getMonth() + 1 + "";
  const year = d.getFullYear();
  const time = d.toTimeString().split(" ")[0];

  let result = `${year}-${month.padStart(2, "0")}-${date.padStart(
    2,
    "0"
  )}T${time}Z`;
  return result;
}

export function dtFromServerString(val) {
  return new Date(val.replace("T", " ").replace("Z", " "));
}
